import { POSTSEASON_GAME_TYPES } from 'bam-node-baseball-savant/constants/game-types'

// Multi Select Code
export function getMultiSelectValues(modal, placeholder = []) {
    if (!modal) {
        return placeholder
    }
    return [
        ...modal.querySelectorAll('input:checked:not([data-skip-label])'),
    ].map((el) => el.value)
}

export function getAndJoinMultiSelectValues(modal, placeholder = []) {
    return getMultiSelectValues(modal, placeholder).join('|')
}

export function toggleMultiSelect(modal) {
    const isHidden = modal.hasAttribute('hidden')

    if (isHidden) {
        modal.removeAttribute('hidden')
    } else {
        modal.setAttribute('hidden', '')
    }

    // eslint-disable-next-line no-param-reassign
    modal.dataset.open = isHidden
}

document.addEventListener('mousedown', handleClick)
document.addEventListener('click', handleClick)
document.addEventListener('keydown', handleKeyDown)
document.addEventListener('focusout', handleFocusOut)

// Necessary for tabbing away from open modals
function handleFocusOut({ target, relatedTarget }) {
    const savantSelectContainer = target.closest('.savant-select')

    if (!savantSelectContainer) {
        return
    }

    const modal = savantSelectContainer.querySelector(
        '.savant-multi-select-modal'
    )

    if (!modal || modal.hasAttribute('hidden')) {
        return
    }

    const focusStayingInside =
        relatedTarget && savantSelectContainer.contains(relatedTarget)

    if (!focusStayingInside) {
        toggleMultiSelect(modal)
    }
}

function handleKeyDown(e) {
    const { key, target } = e
    const modalTarget = target.querySelector(
        ':scope > .savant-multi-select-modal'
    )

    if (modalTarget && (key === 'Enter' || key === ' ')) {
        // Don't scroll down, can't destructure
        e.preventDefault()

        toggleMultiSelect(modalTarget)
        return
    }

    if (key === 'Escape') {
        const modalParent = target.closest('.savant-multi-select-modal')
        if (modalParent) {
            toggleMultiSelect(modalParent)
        }
    }
}

function handleClick({ target, type }) {
    // mousedown fires when you open a select
    // (in Chrome and FF anyway)
    // whereas click does not. ¯\_(ツ)_/¯
    if (type === 'mousedown' && target.tagName !== 'SELECT') {
        return
    }

    const modal = target.closest('.savant-multi-select-modal')

    const dropdown = target.closest('.savant-multi-select-label')
    if (dropdown) {
        toggleMultiSelect(dropdown.nextElementSibling)
    }

    if (!modal) {
        document
            .querySelectorAll('.savant-multi-select-modal')
            .forEach((el) => {
                if (dropdown?.nextElementSibling !== el) {
                    el.setAttribute('hidden', '')

                    // eslint-disable-next-line no-param-reassign
                    el.dataset.open = 'false'
                }
            })
    }
}

// Could export this generic function for use in specific cases
export function updateLabel(modal, suppressEvent = false) {
    if (!modal) {
        return
    }

    const countLabel = modal.previousElementSibling

    const inputs = modal.querySelectorAll('input')

    const checked = [...inputs].filter(
        (el) => el.checked && !('skipLabel' in el.dataset)
    )
    const labels = checked.map((el) => {
        if (el.dataset.label) {
            return el.dataset.label
        }

        const label = document.querySelector(`label[for="${el.id}"]`)

        if (!label) {
            return ''
        }

        return label.textContent.trim()
    })

    let checkedString = labels.join(', ')

    if (!checked.length) {
        checkedString = '--'
    }

    countLabel.textContent = checkedString

    // Since we use this function whenever state changes, fire an appropriate event
    const eventDetail = {
        values: getMultiSelectValues(modal),
        joined: getAndJoinMultiSelectValues(modal),
        labels,
        checkedCount: checked.length,
        checkedString,
        modalId: modal.id,
    }

    if (!suppressEvent) {
        const evt = new CustomEvent('multi-select-updated', {
            detail: eventDetail,
            bubbles: true,
            composed: true,
        })

        modal.dispatchEvent(evt)
    }
}

document.addEventListener('change', (e) => {
    const multiSelectInput = e.target.closest('.savant-multi-select-modal')
    if (multiSelectInput) {
        updateLabel(multiSelectInput)
    }
})

// Shared Functionality

export const swingTimingXModal = document.querySelector(
    '#swing-timing-x-multi-select .savant-multi-select-modal'
)
export const swingTimingYModal = document.querySelector(
    '#swing-timing-y-multi-select .savant-multi-select-modal'
)
export const swingTimingZModal = document.querySelector(
    '#swing-timing-z-multi-select .savant-multi-select-modal'
)

// Multi Team - This only works for the default setup (no ddlTeamId in multi-team template)
export const teamModal = document.querySelector(
    '#team-multi-select .savant-multi-select-modal'
)

// Handle Team Toggles
document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-multi-team-toggle]')

    if (toggle) {
        const type = toggle.dataset.multiTeamToggle
        const modal = toggle.closest('.savant-multi-select-modal')

        if (type === 'american' || type === 'national') {
            const teams = modal.querySelectorAll(
                `.multi-select-team-${type} input`
            )

            const someUnchecked = [...teams].some((el) => !el.checked)

            teams.forEach((el) => {
                // eslint-disable-next-line no-param-reassign
                el.checked = someUnchecked
            })

            updateLabel(modal)
        } else if (type === 'clear') {
            const teams = modal.querySelectorAll(`input`)

            teams.forEach((el) => {
                // eslint-disable-next-line no-param-reassign
                el.checked = false
            })

            updateLabel(modal)
        }
    }
})

// Multi Year
export const seasonModal = document.querySelector(
    '#season-multi-select .savant-multi-select-modal'
)

if (seasonModal) {
    updateLabel(seasonModal)
}

const seasonsClear = document.getElementById('season-clear')
const seasonsAll = document.getElementById('season-all')

seasonsClear?.addEventListener('click', () => {
    seasonModal.querySelectorAll('input').forEach((el, i) => {
        // eslint-disable-next-line no-param-reassign
        el.checked = i === 0
    })

    updateLabel(seasonModal)
})

seasonsAll?.addEventListener('click', () => {
    seasonModal.querySelectorAll('input').forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.checked = true
    })

    updateLabel(seasonModal)
})

// Counts
export const countModal = document.querySelector(
    '#count-multi-select .savant-multi-select-modal'
)

const twoStrike = document.getElementById('two-strike-toggle')
const threeBall = document.getElementById('three-ball-toggle')
const countClear = document.getElementById('count-clear')

twoStrike?.addEventListener('click', () => {
    const counts = ['02', '12', '22', '32']
    const ids = counts.map((count) => `count-${count}`)
    const els = ids.map((id) => document.getElementById(id)).filter((d) => d)

    const someUnchecked = els.some((el) => !el.checked)

    els.forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.checked = someUnchecked
    })

    updateLabel(countModal)
})

threeBall?.addEventListener('click', () => {
    const counts = ['30', '31', '32']
    const ids = counts.map((count) => `count-${count}`)
    const els = ids.map((id) => document.getElementById(id)).filter((d) => d)

    const someUnchecked = els.some((el) => !el.checked)

    els.forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.checked = someUnchecked
    })

    updateLabel(countModal)
})

countClear?.addEventListener('click', () => {
    countModal.querySelectorAll('input').forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.checked = false
    })

    updateLabel(countModal)
})

export const groupByModal = document.querySelector(
    '#group-by-multi-select .savant-multi-select-modal'
)

export const gameTypeModal = document.querySelector(
    '#game-type-multi-select .savant-multi-select-modal'
)

const postSeasonGameType = document.getElementById(
    'postseason-game-type-toggle'
)
const allGameType = document.getElementById('all-game-types-toggle')
const gameTypeClear = document.getElementById('game-type-clear')

postSeasonGameType?.addEventListener('click', () => {
    const ids = POSTSEASON_GAME_TYPES.map((count) => `game-type-${count}`)
    const els = ids.map((id) => document.getElementById(id)).filter((d) => d)

    const someUnchecked = els.some((el) => !el.checked)

    els.forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.checked = someUnchecked
    })

    updateLabel(countModal)
})

allGameType?.addEventListener('click', () => {
    const inputs = [...gameTypeModal.querySelectorAll('input')]

    const someUnchecked = inputs.some((el) => !el.checked)

    inputs.forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.checked = someUnchecked || el.value === 'R'
    })

    updateLabel(countModal)
})
gameTypeClear?.addEventListener('click', () => {
    gameTypeModal.querySelectorAll('input').forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.checked = el.value === 'R'
    })

    updateLabel(countModal)
})

export const shadowZoneModal = document.querySelector(
    '#shadow-zone-multi-select .savant-multi-select-modal'
)

const topShadowZone = document.getElementById('top-shadow-zone-toggle')
const bottomShadowZone = document.getElementById('bottom-shadow-zone-toggle')
const sideShadowZone = document.getElementById('side-shadow-zone-toggle')
const clearShadowZone = document.getElementById('clear-shadow-zone')

topShadowZone?.addEventListener('click', () => {
    const topZones = ['11', '12', '13']
    const ids = topZones.map((zone) => `shadow-zone-${zone}`)
    const els = ids.map((id) => document.getElementById(id)).filter((d) => d)

    const someUnchecked = els.some((el) => !el.checked)

    els.forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.checked = someUnchecked
    })

    updateLabel(shadowZoneModal)
})

bottomShadowZone?.addEventListener('click', () => {
    const bottomZones = ['17', '18', '19']
    const ids = bottomZones.map((zone) => `shadow-zone-${zone}`)
    const els = ids.map((id) => document.getElementById(id)).filter((d) => d)

    const someUnchecked = els.some((el) => !el.checked)

    els.forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.checked = someUnchecked
    })

    updateLabel(shadowZoneModal)
})

sideShadowZone?.addEventListener('click', () => {
    const sideZones = ['14', '16']
    const ids = sideZones.map((zone) => `shadow-zone-${zone}`)
    const els = ids.map((id) => document.getElementById(id)).filter((d) => d)

    const someUnchecked = els.some((el) => !el.checked)

    els.forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.checked = someUnchecked
    })

    updateLabel(shadowZoneModal)
})

clearShadowZone?.addEventListener('click', () => {
    shadowZoneModal.querySelectorAll('input').forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.checked = false
    })

    updateLabel(shadowZoneModal)
})

// Multi Select Groups - Ripped from Statcast Search
function getAllChildrenInputs(parent) {
    return [
        ...parent
            .closest('.multi-select-parent')
            .nextElementSibling.querySelectorAll(
                ':not(.multi-select-parent) input'
            ),
    ]
}
const groups = document.querySelectorAll('.multi-select-parent > input')

groups.forEach((el) => {
    el.addEventListener('change', (e) => {
        const parentInput = e.target
        const { checked } = parentInput

        const children = getAllChildrenInputs(parentInput)

        children.forEach((input) => {
            // eslint-disable-next-line no-param-reassign
            input.checked = checked
        })
    })

    // Set initial values
    const children = getAllChildrenInputs(el)

    if (children.every((input) => input.checked)) {
        // eslint-disable-next-line no-param-reassign
        el.checked = true
    }
})

function getParentInput(child) {
    try {
        const wrapper = child.closest('.multi-select-children')

        return wrapper.previousElementSibling.querySelector('input')
    } catch (e) {
        return null
    }
}

function uncheckParent(parent) {
    // eslint-disable-next-line no-param-reassign
    parent.checked = false

    const grandParent = getParentInput(parent)

    if (grandParent) {
        uncheckParent(grandParent)
    }
}

function checkParent(parent) {
    const children = getAllChildrenInputs(parent)

    if (children.every((input) => input.checked)) {
        // eslint-disable-next-line no-param-reassign
        parent.checked = true
    }

    const grandParent = getParentInput(parent)

    if (grandParent) {
        checkParent(grandParent)
    }
}

const childrenInputs = document.querySelectorAll('.multi-select-children input')

childrenInputs.forEach((el) => {
    el.addEventListener('change', (e) => {
        const { checked } = e.target

        const parentInput = getParentInput(el)
        if (!checked) {
            uncheckParent(parentInput)
        } else {
            checkParent(parentInput)
        }
    })
})

export const pitchTypeModal = document.querySelector(
    '#pitch-type-multi-select .savant-multi-select-modal'
)

// Flags modify native functionality a bit. Should we do this?
document.querySelectorAll('.filters-flag-label').forEach((el) => {
    el.addEventListener('click', (e) => {
        e.preventDefault() // Take away the nice native part of it

        // This requires very specific HTML ordering. Feels wrong
        const [isEl, isNotEl] = e.target.parentNode.querySelectorAll('input')
        const changeEvent = new Event('change', { bubbles: true })

        if (isEl.checked) {
            isEl.checked = false
            isNotEl.checked = true
            // Important for this to be the positive checked event
            isNotEl.dispatchEvent(changeEvent)
        } else if (isNotEl.checked) {
            isEl.checked = false
            isNotEl.checked = false
            isEl.dispatchEvent(changeEvent)
        } else {
            isEl.checked = true
            isNotEl.checked = false
            isEl.dispatchEvent(changeEvent)
        }
    })
})

const $flagInputs = document.querySelectorAll('#flags-multi-select input')
$flagInputs.forEach((el) => {
    el.addEventListener('change', (e) => {
        // This requires very specific HTML ordering. Feels wrong
        const [isEl, isNotEl] = e.target.parentNode.querySelectorAll('input')

        if (e.target === isEl) {
            isNotEl.checked = false
        } else {
            isEl.checked = false
        }
    })
})

export function getFlags() {
    const flags = {}
    $flagInputs.forEach((el) => {
        if (el.checked) {
            flags[el.name] = 1
        }
    })

    return flags
}
